import { chatsMessageString, currentChats, currentChatsWithGuideMessage, currentChatsWithHistoryConfig } from "./chat";
export var chatSelectors = {
  chatsMessageString: chatsMessageString,
  currentChats: currentChats,
  currentChatsWithGuideMessage: currentChatsWithGuideMessage,
  currentChatsWithHistoryConfig: currentChatsWithHistoryConfig
};